import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useUserDelete = (defaultId) => {
  const deleteUser = useCallback((id = defaultId) => {
    return new Request(`${API_BASE_URL}/api/v2/user/${id}/`, {
      method: "DELETE",
    });
  }, []);
  return useRestMutation(deleteUser);
};

export default useUserDelete;
